(function () {
    'use strict';

    WhistleOut.Tablets = {};

    WhistleOut.Tablets.bindByoPopover = function (
        sourceElement,
        title,
        content,
        optionSelectedCallback,
        placementOverride
    ) {
        if (content && content.length > 0) {
            if (!placementOverride) {
                placementOverride = 'top';
            }

            wo$('body').off('click', WhistleOut.Tablets.hideByoPopover).click(WhistleOut.Tablets.hideByoPopover);
            wo$(sourceElement)
                .off('click')
                .on('click', function () {
                    wo$(sourceElement)
                        .off('shown.bs.popover')
                        .on('shown.bs.popover', function () {
                            wo$('input[data-sim-type]').each(function () {
                                // eslint-disable-next-line @typescript-eslint/no-this-alias
                                var simTypeInput = this;
                                wo$(simTypeInput)
                                    .off('click')
                                    .click(function () {
                                        var simType = wo$(simTypeInput).data('sim-type');
                                        var simTypeName = wo$(simTypeInput).data('sim-type-name');
                                        wo$(sourceElement).popover('destroy');
                                        optionSelectedCallback(simType, simTypeName);
                                    });
                            });
                            wo$('a[data-byo-type-expander]')
                                .off('click')
                                .click(function () {
                                    var spanToExpand = wo$(this).parent().find('[data-byo-type-subline]');

                                    wo$('[data-byo-type-subline]').each(function () {
                                        var currentSpan = wo$(this);

                                        if (currentSpan.is(spanToExpand) && currentSpan.hasClass('text-truncate')) {
                                            currentSpan.removeClass('text-truncate');
                                            currentSpan.removeClass('text-nowrap');
                                        } else {
                                            currentSpan.addClass('text-nowrap');
                                            currentSpan.addClass('text-truncate');
                                        }
                                    });
                                });
                        });

                    if (wo$(sourceElement).data('bs.popover')) {
                        wo$(sourceElement).popover('toggle');
                    } else {
                        wo$(sourceElement).popover({
                            container: 'body',
                            placement: placementOverride,
                            trigger: 'manual',
                            html: true,
                            title: title,
                            content: content
                        });
                        wo$(sourceElement).popover('show');
                    }
                });
        } else {
            wo$(sourceElement).click(function () {
                optionSelectedCallback(null, null);
            });
        }
    };

    WhistleOut.Tablets.hideByoPopover = function (e) {
        wo$('[data-show-byo-button]').each(function () {
            var $this = wo$(this);
            if (
                !$this.is(e.currentTarget) &&
                $this.has(e.currentTarget).length === 0 &&
                wo$('.popover').has(e.currentTarget).length === 0
            ) {
                $this.popover('destroy');
            }
        });
    };

    WhistleOut.Tablets.bindTabletPickerPopover = function (sourceElement, content, tabletSelected) {
        wo$('body')
            .off('click', WhistleOut.Tablets.hideTabletPickerPopover)
            .click(WhistleOut.Tablets.hideTabletPickerPopover);
        wo$(sourceElement)
            .off('click')
            .on('click', function () {
                wo$(sourceElement)
                    .off('shown.bs.popover')
                    .on('shown.bs.popover', function () {
                        wo$('[data-tablet-picker-button]').click(function () {
                            wo$(sourceElement).popover('destroy');
                            WhistleOut.Tablets.showTabletPicker(false, tabletSelected);
                        });
                        wo$('[data-tablet-picker-wizard-button]').click(function () {
                            wo$(sourceElement).popover('destroy');
                            WhistleOut.Tablets.showTabletPicker(true, tabletSelected);
                        });
                    });

                if (wo$(sourceElement).data('bs.popover')) {
                    wo$(sourceElement).popover('toggle');
                } else {
                    wo$(sourceElement).popover({
                        container: 'body',
                        placement: 'top',
                        trigger: 'manual',
                        html: true,
                        content: content
                    });
                    wo$(sourceElement).popover('show');
                }
            });
    };

    WhistleOut.Tablets.hideTabletPickerPopover = function (e) {
        wo$('[data-show-tablet-modal]').each(function () {
            var $this = wo$(this);
            if (
                !$this.is(e.currentTarget) &&
                $this.has(e.currentTarget).length === 0 &&
                wo$('.popover').has(e.currentTarget).length === 0
            ) {
                $this.popover('destroy');
            }
        });
    };

    WhistleOut.Tablets.showTabletPicker = function (wizardMode, tabletSelected) {
        WhistleOut.tabletPickerController.show(wizardMode, tabletSelected);
    };
})();
